var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8525 10.0419C18.8525 14.9311 14.8892 18.8944 10 18.8944C5.1109 18.8944 1.14758 14.9311 1.14758 10.0419C1.14758 5.15277 5.1109 1.18945 10 1.18945C14.8892 1.18945 18.8525 5.15277 18.8525 10.0419Z",
    fill: "#65AA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07008 14.345C8.7925 14.345 8.51342 14.2572 8.27825 14.0775L4.6035 10.3402C4.0361 9.90705 3.93088 9.10057 4.3686 8.53896C4.80618 7.97749 5.62099 7.87335 6.18839 8.30646L8.91267 11.3184L13.3956 6.4076C13.876 5.88138 14.6964 5.84021 15.2282 6.31584C15.7598 6.7912 15.8014 7.60334 15.3209 8.12956L10.0333 13.9217C9.77832 14.2011 9.42542 14.345 9.07008 14.345Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.92a358052025aa7c1c9731783bdb0d1e.svg";
export { ForwardRef as ReactComponent };